<!-- 我的页面 -->
<template>
  <div class v-show="returnData.display">
    <!-- 滑动显示-->
    <div class="display-title" v-if="returnData.name">
      {{ returnData.name }}
    </div>
    <swiper class="good-swiper" :options="goodswiperOption" v-if="true">
      <!-- 分3种情况 1个 -->
      <template v-if="returnData.nextDetailsDTOs[0].logs.length == 0">
        <swiper-slide v-for="(item, index) in 3" :key="index">
          <!-- <div class="deaultimgwrap"> -->
          <div class="auto-height nolist">
            <div class="covers"></div>
            <img
              class="deaultimg"
              src="@/assets/image/tbm/defaultsmallicon.png"
            />
          </div>
          <!-- </div> -->
          <div
            class="goodinfo"
            ::class="{LEFT:returnData.nextDetailsDTOs[0].location=='LEFT'?true:false}"
          >
            <div class="good_name">日志名称</div>
          </div>
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </template>
      <template else>
        <swiper-slide
          v-for="(item, index) in returnData.nextDetailsDTOs[0].logs"
          :key="index"
        >
          <!-- <div class="imgwrap"> -->
          <div :class="['img-cover', item.imgLoaded ? 'imgloaded' : '']">
            <div class="auto-height" @click="goBlogDetail(item)">
              <div class="covers"></div>
              <img class="img" :src="item.imgLoaded ? item.halfCover : ''" />
            </div>
            <!-- </div> -->
            <div
              class="goodinfo"
              @click="goBlogDetail(item)"
              :class="{
                LEFT:
                  returnData.nextDetailsDTOs[0].location == 'LEFT'
                    ? true
                    : false,
              }"
            >
              <div
                class="goodinfo"
                :class="{
                  LEFT:
                    returnData.nextDetailsDTOs[0].location == 'LEFT'
                      ? true
                      : false,
                }"
              >
                <div class="good_name">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </template>
    </swiper>
    <!-- 列表显示-->
    <div class="good-list" v-else>
      <template
        v-if="
          returndata.goodlist.length == 0 && returndata.grouplist.length == 0
        "
      >
        <div class="good-item" v-for="(item, index) in 3" :key="index">
          <div class="deaultimgwrap">
            <img
              class="deaultimg"
              src="@/assets/image/tbm/defaultsmallicon.png"
            />
          </div>
          <div
            class="goodinfo"
            :class="{ left: returndata.positon == 'left' ? true : false }"
          >
            <div class="good_name">日志名称</div>
          </div>
        </div>
      </template>
      <template
        v-if="
          returndata.goodbytype == 'product' && returndata.goodlist.length > 0
        "
      >
        <div
          class="good-item"
          v-for="(item, index) in returndata.goodlist"
          :key="index"
        >
          <div class="imgwrap">
            <img class="img" :src="item.url" />
          </div>
          <div
            class="goodinfo"
            :class="{ left: returndata.positon == 'left' ? true : false }"
          >
            <div class="good_name">{{ item.name }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
  // import引入的组件需要注入到对象中才能使用
  name: "GoodDisplay",
  components: {},
  props: {
    returnData: {
      type: Object,
      required: false,
    },
    componentIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    // 这里存放数据
    return {
      ossSuffix:this.$store.state.ossSuffix,
      goodswiperOption: {
        observer: true, //轮播元素为内部动态添加必须加此 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        slidesPerView: 2.1,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    returnData: {
      immediate: true,
      handler(val, oldVal) {},
      deep: true, //true 深度监听
    },
  },
  methods: {
    loadImages(i) {
      var that = this;
      var img = new Image();
      img.onload = function () {
        //检测是否支持webp格式
        let imgsec = that.returnData.nextDetailsDTOs[0].logs[0].halfCover;
        let flag = that.$utils.checkIsUpdatetoWebp(this, imgsec);
        if (flag) {
          var logs = that.returnData.nextDetailsDTOs[0].logs;
          logs[0].halfCover = that.$utils.replaceImage( logs[0].halfCover ) + that.ossSuffix;
          if (logs.length > 1) {
            logs[1].halfCover =  that.$utils.replaceImage(logs[1].halfCover) + that.ossSuffix;
          }
          that.$set(that.returnData.nextDetailsDTOs[0], `logs`, logs);
        }
        that.$set(
          that.returnData.nextDetailsDTOs[0].logs[i],
          `imgLoaded`,
          true
        );
        if (i == 0 && this.componentIndex == 0) that.$emit("loadingFun");
        let count = i + 1;
        if (count < that.returnData.nextDetailsDTOs[0].logs.length) {
          that.loadImages(count);
        }
      };
      img.onerror = function () {
        that.$set(
          that.returnData.nextDetailsDTOs[0].logs[i],
          `imgLoaded`,
          true
        );
        if (i == 0 && this.componentIndex == 0) that.$emit("loadingFun");
        let count = i + 1;
        if (count < that.returnData.nextDetailsDTOs[0].logs.length) {
          that.loadImages(count);
        }
      };
      let flag = that.$utils.checkIsUpdatetoWebp(
        this,
        that.returnData.nextDetailsDTOs[0].logs[0].halfCover
      );
      if (flag) {
        img.src =
          that.$utils.replaceImage( that.returnData.nextDetailsDTOs[0].logs[0].halfCover )+
          that.ossSuffix;
      } else {
        img.src = that.returnData.nextDetailsDTOs[0].logs[0].halfCover;
      }
    },
    goBlogDetail(item) {
      this.$router.push({
        name: "article",
        params: {
          friendly_url: item.friendlyUrl,
        },
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // var swiper = new Swiper(".swiper-container", {
    //   pagination: ".swiper-pagination",
    //   slidesPerView: 2,
    //   paginationClickable: true,
    //   slidesPerView: "auto",
    //   spaceBetween: 30,
    //   freeMode: true
    // });
    if(this.$utils.isMobile()){
      this.ossSuffix = "?x-oss-process=style/tb_mobilehp_post_400"; 
    }
    this.loadImages(0);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
};
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.display-title {
  padding: 0 2rem 2.8rem;
  text-align: left;
  font-size: 1.8rem;
  color: #000;
  font-family: ArialNarrow, sans-serif;
}
.good-swiper {
  padding: 0 2rem 2.8rem;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.good-list {
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 1rem;
  .good-item {
    width: 50%;
    padding: 0 1rem;
    margin-bottom: 2rem;
  }
}
.imgwrap {
  min-height: 21.8rem;
  height: auto;
  .img {
    width: 100%;
    min-height: 21.8rem;
    height: auto;
    object-fit: cover;
  }
}
// .deaultimgwrap {
//   width: 100%;
//   height: 21rem;
//   background: #e3f0ff;
//   position: relative;
// }
.img-cover {
  opacity: 0;
  &.imgloaded {
    opacity: 1;
    transition: opacity 0.3s ease-in-out 0.3s;
  }
}
.auto-height {
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 132%;
  // background: center no-repeat #ffffff;
  background-size: contain;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &.nolist {
    background: #e3f0ff;
  }
  &:hover {
    filter: initial;
  }
  .covers {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .banner-img {
    min-height: 3rem;

    max-width: 100%;
    vertical-align: middle;
    object-fit: cover;
  }
}

.deaultimg {
  width: 3.5rem;
  height: 3.5rem;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.goodinfo {
  text-align: left;
  margin-top: 9px;
  color: #5c5d5f;
  &.left {
    text-align: left;
  }
  .good_name {
    font-weight: 400;
    font-family: ArialNarrow, sans-serif;
  }
}
@media screen and (min-width: 10240px) {
  .deaultimgwrap {
    height: 42rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/Blog.vue